import { gsap } from 'gsap';
import Lenis from 'lenis';


//
// lenis init
//
if (window.matchMedia('(pointer: fine)').matches) {
    const lenis = new Lenis({
        autoRaf: true,
    });
}


//
// cursor
//
let cursor = document.querySelector('.cursor');

if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mousemove', event => {
        gsap.to(cursor, {
            x: event.clientX +'px',
            y: event.clientY +'px',
            duration: .4
        });
    });

    document.addEventListener('pointerdown', () => {
        cursor.toggleAttribute('data-down', true);
    });

    document.addEventListener('pointerup', () => {
        cursor.toggleAttribute('data-down', false);
    });

    document.querySelectorAll('a, button').forEach(element => {
        element.addEventListener('mouseenter', () => {
            cursor.toggleAttribute('data-hover', true);
        });

        element.addEventListener('mouseleave', () => {
            cursor.toggleAttribute('data-hover', false);
        });
    });
}


//
// hero - enter
//
const heroStartTL = gsap.timeline({
    delay: 1
});

heroStartTL.from('.hero-wave-green', {
    y: '+=250',
    duration: 1,
    ease: 'poser2.inOut'
}, 'start');

heroStartTL.from('.hero-wave-tan', {
    y: '+=450',
    duration: 1,
    ease: 'poser2.inOut'
}, 'start+=.2');


//
// hero - circle
//
const circlePath = document.querySelector('#circlePath');

const
    circleX = 50,
    circleY = 50,
    circleRadius = 40;

circlePath.setAttribute('d', `M ${circleX - circleRadius},${circleY} a ${circleRadius},${circleRadius} 0 1,1 ${(2 * circleRadius)},0 ${circleRadius},${circleRadius} 0 1,1 ${-2 * circleRadius},0`)


//
// music
//
const
    musicPlay = document.querySelector('.music-play'),
    musicAudio = document.querySelector('.music-audio');

musicAudio.volume = .1;

musicPlay.addEventListener('click', () => {
    if (musicAudio.paused) {
        musicAudio.play();
        musicPlay.innerHTML = 'pause';
    } else {
        musicAudio.pause();
        musicPlay.innerHTML = 'play';
    }
});
